import { memo } from 'react'
import { DepositItem } from '../deposits-list/deposit-item'
import { useRecoilValue } from 'recoil'
import { selectedAccountState } from '../../states/selected-account-id'
import { ACLContainer } from '../acl-container/acl-container'

const Component = () => {
  const deposits = []

  return (
    <div className="mb-4 mt-4">
      <h1 className="text-2xl font-bold">My Withdrawals</h1>
      <table className="table table-compact w-full b-4 mt-4 mb-4">
        <thead>
          <tr>
            <th>Amount</th>
            <th>Date</th>
            <th>Status</th>
            <ACLContainer onlyManagement isEditableOnly>
              <th>Account</th>
              <th />
            </ACLContainer>
          </tr>
        </thead>
      </table>
      {deposits.length === 0 && (
        <div className="alert alert-primary">
          <div>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              className="stroke-current flex-shrink-0 w-6 h-6">
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
              />
            </svg>
            <span>No withdrawals yet</span>
          </div>
        </div>
      )}
    </div>
  )
}

export const MyWithdrawals = memo(Component)